// credit Hungry Ram

// var headers = document.querySelectorAll('#main-content h2');

// headers.forEach(function (header, index) {

//   header.id = 'section-' + index;
//   var tocContainer = document.getElementById('post-content-table-of-contents');
//   var anchor = document.createElement('a');
//   anchor.setAttribute('href', '#' + header.id);
//   anchor.innerText = header.textContent;
//   tocContainer.appendChild(anchor);

// });

(function() {
  var headers = document.querySelectorAll('#main-content h2');
  var tocContainer = document.getElementById('post-content-table-of-contents');
  var tocWrapper = document.getElementById('post-content-toc-wrapper');

  // Exit early if any required element is missing
  if (!tocContainer || !tocWrapper || headers.length === 0) return;

  headers.forEach(function(header, index) {
    header.id = 'section-' + index;

    var anchor = document.createElement('a');
    anchor.setAttribute('href', '#' + header.id);
    anchor.innerText = header.textContent;
    tocContainer.appendChild(anchor);
  });

  // Show the wrapper only if links were added
  if (tocContainer.children.length > 0) {
    tocWrapper.style.display = 'block';
  }
})();